import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page mx-auto p-3 w-330 mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "密码登录", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "短信登录", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
      onTabClick: _ctx.handleClick,
      stretch: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { name: "PwdLogin" }, {
          label: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "MobileLogin" }, {
          label: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
      ]),
      _: 1
    })
  ]))
}